module.exports = __webpack_public_path__ + "static/img/logo-vancouver-island.d9693c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/complete/logo-vancouver-island.png
// module id = PqEt
// module chunks = 0